import shuffle from 'lodash/shuffle';
import {
  MediaData,
  MatrixNodeData,
  MatrixData,
  MultipleChoiceMediaData,
} from '../../../types/quiz';
import { parseStringWithNode } from './utils';

/**
 * OrderData.
 */
export const mapMatrixData = ({
  data,
  mediaData,
}: {
  data: MatrixNodeData;
  mediaData: MediaData<MultipleChoiceMediaData[]>;
}): MatrixData => {
  return {
    question: parseStringWithNode(data.q, mediaData),
    keyTakeaway: parseStringWithNode(data.kp?.s, mediaData),
    answers: {
      rows: [...shuffle(data.a.rows)],
      columns: data.a.columns,
      optionsHeader: data.a.optionsHeader,
    },
  };
};
